module.exports = __webpack_public_path__ + "static/media/20240503141150_IMG_6648.27f3b2d2.JPG";